<div class="component-container">
  <div class="attribute-editor-component">
    <button
      rv-button
      variant="secondary"
      id="addPlaceholderButton"
      class="mb-2 tw-w-full"
      (click)="placeholdersService.addNewPlaceholder()"
    >
      Add
    </button>
    <div class="editor-playlist workspace-sidebar-body">
      @for (
        placeholder of placeholdersService.getPlaceholders();
        track placeholder
      ) {
        <div class="editor-playlist-item attribute-row attribute-row-hover">
          <div class="attribute-desc mr-auto">
            <streamline-icon
              aria-hidden="true"
              class="streamline-component-icon"
              name="playlist"
              width="24"
              height="18"
            ></streamline-icon>
            <a rv-link id="manageLink" (click)="manage(placeholder)">{{
              placeholder.id
            }}</a>
          </div>
          <button
            type="button"
            mat-icon-button
            id="duplicateButton"
            aria-label="Duplicate placeholder"
            (click)="placeholdersService.duplicatePlaceholder(placeholder)"
          >
            <streamline-icon
              class="ml-3 mr-0 streamline-component-icon"
              name="copy"
              width="16"
              height="18"
            ></streamline-icon>
          </button>
          <button
            type="button"
            mat-icon-button
            id="removeButton"
            aria-label="Remove placeholder"
            (click)="remove(placeholder)"
          >
            <streamline-icon
              class="ml-3 streamline-component-icon"
              name="trash"
              width="16"
              height="18"
            ></streamline-icon>
          </button>
        </div>
      }
      <div [hidden]="placeholdersService.getPlaceholders().length">
        <div class="panel-body">
          <p class="text-muted text-center u_remove-bottom">
            You haven't added any Placeholders to your Presentation yet.
          </p>
        </div>
      </div>
    </div>
  </div>
</div>
